import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.invoiceLogsTab.title, 'Logs'),
  logDate: () => __(translations.invoiceLogsTab.logDate, 'Date'),
  user: () => __(translations.invoiceLogsTab.user, 'User'),
  action: () => __(translations.invoiceLogsTab.action, 'Action'),
};
